import script from "./SCU.vue?vue&type=script&setup=true&lang=js"
export * from "./SCU.vue?vue&type=script&setup=true&lang=js"

import "./SCU.vue?vue&type=style&index=0&id=07c9a848&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07c9a848"]])

export default __exports__